import { Component } from '@angular/core';

@Component({
  selector: 'app-procesar-pago',
  standalone: false,
  templateUrl: './procesar-pago.component.html',
  styleUrl: './procesar-pago.component.scss'
})

export class ProcesarPagoComponent {

}
